import { render, staticRenderFns } from "./CompleteIdChecks.vue?vue&type=template&id=8a1d95c4"
import script from "./CompleteIdChecks.vue?vue&type=script&lang=js"
export * from "./CompleteIdChecks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports